import { getAssetCounts } from '../api';

import renderCartCount from './renderCartCount';
import renderRoomCount from './renderRoomCount';
import renderWishListCount from './renderWishlistCount';
import renderTotalSavedPortfolioCount from './renderTotalSavedPortfolioCount';

function updateCounts () {

	const { lp } = window.top;

	getAssetCounts(lp.globals.isCustomerConnected)
		.then((response) => response.json())
		.then(({ CartItemCount, SceneCount, WishlistItemCount }) => {

			lp.globals.cartCount = CartItemCount;
			lp.globals.roomCount = SceneCount;
			lp.globals.wishlistItemCount = WishlistItemCount;
			renderCartCount(CartItemCount);
			if (lp.globals.isCustomerService) {

				renderRoomCount(SceneCount);
				renderWishListCount(WishlistItemCount);
				renderTotalSavedPortfolioCount(SceneCount + WishlistItemCount);

			} else {

				renderTotalSavedPortfolioCount(WishlistItemCount);

			}

		})
		.catch(() => {

			if (lp.globals.isCustomerService) {

				renderRoomCount(0);

			}

		});

}

export default updateCounts;
